module.exports = __webpack_public_path__ + "img/logo-small.9ee22281.svg";